var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',[(this.$route.name === 'Home')?_c('router-view'):_vm._e()],1)],1),_c('transition',{attrs:{"name":_vm.transitionName}},[(this.$route.name != 'Home')?_c('router-view'):_vm._e()],1),_c('transition',{attrs:{"name":"fade"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }